import React from 'react';
import TradingWorkspace from './components/TradingWorkspace';

export default function App() {
  return <TradingWorkspace />;
}
